var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"w-100 text-right pr-2"},[_vm._v(" "+_vm._s(_vm.Value != undefined && isFinite(_vm.Value) ? Intl.NumberFormat('fr-FR', { minimumFractionDigits: _vm.Header.MinDecimal, maximumFractionDigits: _vm.Header.MaxDecimal }).format(_vm.Value) : '')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }